<div class="cpcontent">
  <button class="btn btn-secondary btn-sm mb-3" (click)="back()">← Back to Performance</button>
  <h1>Exercise Analysis</h1>
  <h5 *ngIf="exerciseId">Exercise: {{exerciseId}}</h5>

  <table class="table table-bordered">
    <thead>
      <tr>
        <th class="link" (click)="sortBy('property')">Player Name {{sortField==='property' ? (sortAsc ? '▲' : '▼') : ''}}</th>
        <th>registeredAt</th>
        <th>Platform</th>
        <th>Mobile</th>
        <th>Browser</th>
        <th class="link" (click)="sortBy('loadDuration')">Loading [ms] {{sortField==='loadDuration' ? (sortAsc ? '▲' : '▼') : ''}}</th>
        <th class="link" (click)="sortBy('renderDuration')">Render [ms] {{sortField==='renderDuration' ? (sortAsc ? '▲' : '▼') : ''}}</th>
        <th class="link" (click)="sortBy('fps')">FPS {{sortField==='fps' ? (sortAsc ? '▲' : '▼') : ''}}</th>
        <th class="link" (click)="sortBy('avgRenderTime')">Avg Render [ms] {{sortField==='avgRenderTime' ? (sortAsc ? '▲' : '▼') : ''}}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let e of players">
        <td class="link" (click)="showPlayer(e)">{{e.property}}</td>
        <td>{{e.registeredAt}}</td>
        <td>{{e.platform}}</td>
        <td>{{e.mobile}}</td>
        <td>{{e.browser}}</td>
        <td>{{e.loadDuration | number: '1.0-0'}}</td>
        <td>{{e.renderDuration | number: '1.1-1'}}</td>
        <td>{{e.fps | number: '1.0-0'}}</td>
        <td>{{e.avgRenderTime | number: '1.1-1'}}</td>
      </tr>
    </tbody>
  </table>

  <button class="btn btn-info btn-sm" (click)="showRawData = !showRawData">Show / Hide Raw Data</button>
  <div *ngIf="showRawData" style="margin-top:10px;white-space:pre-wrap;font-family:monospace;font-size:12px;">
    {{players | json}}
  </div>
</div>

<!-- Player Details Modal -->
<div *ngIf="showPlayerModal" class="cpmodal">
  <div class="cpmodal-content">
    <div class="cpmodal-header" style="display:flex;justify-content:space-between;align-items:center">
      <span>Player Details</span>
      <button class="btn btn-outline-light btn-sm" (click)="reloadPlayer()"><i class="bi bi-arrow-clockwise me-1"></i>Refresh</button>
    </div>

    <h5>Header</h5>
    <table class="table table-bordered table-sm">
      <thead>
        <tr>
          <th>Exercise</th>
          <th>Player Name</th>
          <th>Registered At</th>
          <th>IP</th>
          <th>Location</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><b>{{exerciseId}}</b></td>
          <td><b>{{selectedPlayer.player}}</b></td>
          <td>{{selectedPlayer.registeredAt}}</td>
          <td>{{selectedPlayer.ip}}</td>
          <td>{{ipLocation ? (ipLocation.city + ', ' + ipLocation.region + ' ' + ipLocation.country) : '...'}}</td>
        </tr>
      </tbody>
    </table>

    <div class="row">
      <div class="col-md-6">
        <h5>Operating System</h5>
        <table class="table table-bordered table-sm">
          <tbody>
            <tr><td>Platform</td><td>{{selectedPlayer.platform?.platform}}</td></tr>
            <tr><td>Brand</td><td>{{selectedPlayer.platform?.brands}}</td></tr>
            <tr><td>userAgent</td><td>{{selectedPlayer.userAgent}}</td></tr>
            <tr><td>Mobile</td><td>{{selectedPlayer.platform?.mobile}}</td></tr>
            <tr><td>Logical Processors</td><td>{{selectedPlayer.logicalProcessors}}</td></tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-6">
        <h5>Graphics Card</h5>
        <table class="table table-bordered table-sm">
          <tbody>
            <tr><td>renderer</td><td>{{selectedPlayer.gpuInfo?.renderer}}</td></tr>
            <tr><td>vendor</td><td>{{selectedPlayer.gpuInfo?.vendor}}</td></tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <h5>Loading Time</h5>
        <table class="table table-bordered table-sm">
          <tbody>
            <tr><td>Time to First Render [ms]</td><td>{{selectedPlayer.initiationTime?.initiationTime | number: '1.0-0'}}</td></tr>
            <tr><td>Component loading [ms]</td><td>{{selectedPlayer.loadComponents?.duration_ms | number: '1.0-0'}}</td></tr>
            <tr><td>Interactivity Loading [ms]</td><td>{{selectedPlayer.interactivities?.loadingTime | number: '1.0-0'}}</td></tr>
          </tbody>
        </table>
        <b>Components</b> with file size {{totalComponentFileSize | number: '1.0-0'}} KB<br>
        <button class="btn btn-info btn-sm mt-1" (click)="showComponentDownload = !showComponentDownload">Show / Hide Components</button>
        <table *ngIf="showComponentDownload" class="table table-bordered table-sm mt-1">
          <thead>
            <tr><th>Name</th><th>File Size (KB)</th><th>Load Time [ms]</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of selectedPlayer.loadComponents?.formattedDetails">
              <td>{{c.Name}}</td>
              <td>{{c.FileSizeKB | number: '1.0-0'}}</td>
              <td>{{c.LoadTimeMS | number: '1.0-0'}}</td>
            </tr>
          </tbody>
        </table>
        <br>
        <b>Interactivities</b><br>
        <button class="btn btn-info btn-sm mt-1" (click)="showInteractivities = !showInteractivities">Show / Hide Interactivities</button>
        <table *ngIf="showInteractivities" class="table table-bordered table-sm mt-1">
          <thead>
            <tr><th>Name</th><th>Duration [ms]</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let inter of selectedPlayer.interactivities?.interactivityTimes">
              <td>{{inter.name}}</td>
              <td>{{inter.time | number: '1.2-2'}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-md-6">
        <h5>Rendering Time</h5>
        <table class="table table-bordered table-sm">
          <tbody>
            <tr><td>FPS</td><td>{{selectedPlayer.render?.fps}}</td></tr>
            <tr><td>Duration for 100 calls to update [ms]</td><td>{{selectedPlayer.render?.durationFor100CallsMs | number: '1.2-2'}}</td></tr>
            <tr><td>Average Rendering Time [ms]</td><td>{{selectedPlayer.rendering?.averageRenderTime | number: '1.2-2'}}</td></tr>
          </tbody>
        </table>
        Total Time [MS] per second: {{totalCycleLoadTime | number: '1.2-2'}}<br>
        ((Duration for 100 Calls) / 100 + (Average Rendering Time))*FPS
      </div>
    </div>

    <hr>
    <button class="btn btn-secondary btn-sm" (click)="goToFullDetails()">Full Details Page</button>
    <button class="btn btn-primary" style="float:right" (click)="showPlayerModal = false">Close</button>
    <div class="spacer10"></div>
  </div>
</div>
